import InsertNoteFormContent from '@/features/common/components/InsertNoteFormContent'
import { useFormNoteField } from '@/features/pos/components/OrderFinalization/form'
import { usePortal } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/NoteField/contexts/Portal'
import Modal from '@/features/ui/components/Modal'
import { useScreenLayout } from '@/hooks/screen'
import { useHeaderHeight } from '@react-navigation/elements'
import { useCallback, useState } from 'react'
import { ScrollView, StyleSheet } from 'react-native'

export const useNoteModal = (): (() => void) => {
    const [visible, setVisible] = useState(false)

    const [note, onChangeNote] = useFormNoteField()

    const layout = useScreenLayout()
    const headerHeight = useHeaderHeight()

    const hide = useCallback(() => {
        setVisible(false)
    }, [])

    const show = useCallback(() => {
        setVisible(true)
    }, [])

    const handleConfirm = useCallback(
        (nextNote: string) => {
            onChangeNote(nextNote)
            hide()
        },
        [hide, onChangeNote]
    )

    const handleDelete = useCallback(() => {
        onChangeNote(null)
        hide()
    }, [hide, onChangeNote])

    usePortal(
        visible,
        <Modal
            avoidKeyboard
            keyboardAvoidanceVariant="padding"
            keyboardVerticalOffset={headerHeight}
            backdropStyle={layout === 'compact' ? styles.compactBackdrop : undefined}
        >
            <ScrollView keyboardShouldPersistTaps="handled" showsVerticalScrollIndicator={false}>
                <InsertNoteFormContent
                    confirmedNote={note}
                    onConfirm={handleConfirm}
                    onCancel={hide}
                    onDelete={handleDelete}
                />
            </ScrollView>
        </Modal>
    )

    return show
}

const styles = StyleSheet.create({
    compactBackdrop: {
        // The compact portal already ends above the safe-area-padded bottom sheet.
        paddingBottom: 16,
    },
})
